import axios from "@/axios.js";

export default async function getVimeoLink(vimeoId, token) {
  if (vimeoId) {
    const {data} = await axios({
      url: `https://preprodms.embibe.com/coobo_ms/vimeo-playback/${vimeoId}`,
      method: 'get',
      headers: {'embibe-token': token}
    })
    if (data) {
      return data;
    }
  }
  return null;
}
